/*
 * @Descripttion: state
 * @Author: juanjuanhui
 * @Date: 2022-02-19 19:14:34
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-06-07 14:28:06
 */
const state = {
  headMenuPath: "", // 头部菜单路由
  accessToken: "",
};
export default state;
